var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog"},[_c('div',{staticClass:"dialog__title"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('div',{staticClass:"mb-5",domProps:{"innerHTML":_vm._s(_vm.message)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }